import NiceModal from '@ebay/nice-modal-react';
import { Box } from '@mantine/core';

import { useGetAIPromptTemplates } from '../api/getAIPromptTemplates';

import { AddModal } from './AddModal';
import { AIPromptTemplatesTable } from './Table/Table';

import { AddButton, ListLoader } from '@/components';

export const AIPromptTemplatesList = () => {
  const { data, isLoading } = useGetAIPromptTemplates();

  if (isLoading) {
    return <ListLoader />;
  }

  const templates = data?.templates ?? [];
  const maxAiId = templates.reduce((max, t) => {
    const value = Number(t.aiId);
    return Number.isNaN(value) ? max : Math.max(max, value);
  }, 0);
  const nextAiId = maxAiId + 1;

  if (!templates.length) {
    return <ListAddButton isLoading={isLoading} nextAiId={nextAiId} />;
  }

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: 'auto 70px' }}>
      <Box style={{ overflow: 'auto' }}>
        <AIPromptTemplatesTable templates={templates} />
      </Box>
      <ListAddButton isLoading={isLoading} nextAiId={nextAiId} />
    </Box>
  );
};

function ListAddButton({ isLoading, nextAiId }: { isLoading: boolean; nextAiId: number }) {
  return (
    <AddButton
      size={60}
      isLoading={isLoading}
      onClick={() =>
        NiceModal.show(AddModal, {
          initialValues: {
            aiId: nextAiId,
            template: '',
          },
        })
      }
    />
  );
}
